<app-ui-document-panel-shell
  breadcrumb="Procurement / Requisitions"
  [title]="panelTitle"
  [documentId]="req_no || ''"
  [statusLabel]="statusLabel"
  [statusVariant]="statusVariant"
  (closed)="onClose()">

  <app-ui-approval-stepper
    *ngIf="data?.id"
    [steps]="approvalSteps">
  </app-ui-approval-stepper>

  <!-- General Information -->
  <app-ui-form-section title="General Information" icon="info">
    <div class="ui-doc-panel-content__field-grid">
      <div class="ui-doc-panel-content__field" [matTooltip]="document_type" [matTooltipDisabled]="!isInputDisabled" matTooltipPosition="above">
        <mat-form-field appearance="outline">
          <mat-label>Document Type</mat-label>
          <mat-select [(ngModel)]="document_type" (ngModelChange)="onDocumentTypeChange($event)" [disabled]="isInputDisabled">
            <mat-option *ngFor="let type of documentTypes" [value]="type">{{ type }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" [matTooltip]="getBranchName(branch)" [matTooltipDisabled]="!isInputDisabled" matTooltipPosition="above">
        <mat-form-field appearance="outline">
          <mat-label>Branch</mat-label>
          <mat-select #branchSelect [(ngModel)]="branch" (openedChange)="onBranchOpen($event)" (ngModelChange)="onBranchSelect($event)" [disabled]="isInputDisabled" panelClass="branch-select-panel">
            <mat-option disabled class="branch-search-option">
              <input matInput placeholder="Search branch..." (keyup)="onBranchSearch($event.target.value)" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </mat-option>
            <mat-option *ngFor="let data of branchdata" [value]="data.id">{{ data.name }}</mat-option>
            <mat-option *ngIf="loading" disabled>Loading…</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" [matTooltip]="getProfitCostName(selectedProfitCosts)" [matTooltipDisabled]="!isInputDisabled" matTooltipPosition="above">
        <mat-form-field appearance="outline">
          <mat-label>Select Profit Cost<span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select #profitCostSelect [(ngModel)]="selectedProfitCosts" (openedChange)="onProfitCostOpen($event)" (ngModelChange)="onProfitCostChange($event)" [disabled]="isInputDisabled" panelClass="profit-cost-select-panel">
            <mat-option disabled class="profit-cost-search-option">
              <input matInput placeholder="Search profit cost..." (keyup)="onProfitCostSearch($event.target.value)" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
            </mat-option>
            <mat-option *ngFor="let profitcost of PcCcData" [value]="profitcost.id" [disabled]="profitcost.is_active == 0">{{ profitcost.name }}</mat-option>
            <mat-option *ngIf="loadingProfitCost" disabled>Loading…</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" *ngIf="document_type === 'Goods'" [matTooltip]="getStoreName(store_data)" [matTooltipDisabled]="!isInputDisabled" matTooltipPosition="above">
        <mat-form-field appearance="outline">
          <mat-label>Select store <span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="store_data" placeholder="Select Store" (ngModelChange)="onStoreSelected($event)" [disabled]="isInputDisabled || isApprovalStatus">
            <mat-option value="">Select Store</mat-option>
            <mat-option *ngFor="let item of store" [value]="item.id">{{ item.store_name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field" [matTooltip]="getSectionName(selectedSections)" [matTooltipDisabled]="!isInputDisabled" matTooltipPosition="above">
        <mat-form-field appearance="outline">
          <mat-label>Select Section <span class="ui-doc-panel-content__required">*</span></mat-label>
          <mat-select [(ngModel)]="selectedSections" placeholder="Select Section" (openedChange)="onSectionOpen($event)" (ngModelChange)="onSectionSelected($event)" [disabled]="isInputDisabled || isApprovalStatus" panelClass="section-select-panel">
            <mat-option disabled class="section-search-option">
              <input matInput placeholder="Search Section..." (keyup)="onSectionSearch($event.target.value)" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
            </mat-option>
            <mat-option *ngFor="let item of filteredSections" [value]="item.id">{{ item.section_name }}</mat-option>
            <mat-option *ngIf="sectionLoading" disabled>Loading...</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="fill">
          <mat-label>Month and Year<span class="ui-doc-panel-content__required">*</span></mat-label>
          <input matInput [matDatepicker]="picker" [(ngModel)]="selectedDate" [readonly]="true" [disabled]="isInputDisabled" />
          <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isInputDisabled"></mat-datepicker-toggle>
          <mat-datepicker #picker startView="multi-year" (monthSelected)="chosenMonthHandler($event, picker)" (yearSelected)="chosenYearHandler($event)" panelClass="month-picker"></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="ui-doc-panel-content__field">
        <mat-form-field appearance="outline">
          <mat-label>Date <span class="ui-doc-panel-content__required">*</span></mat-label>
          <input type="date" matInput [(ngModel)]="requesition_date" class="custom-input" [max]="today" [disabled]="isInputDisabled" (keydown)="$event.preventDefault()">
        </mat-form-field>
      </div>
    </div>
  </app-ui-form-section>

  <!-- Add Line Item -->
  <app-ui-form-section *ngIf="panelMode !== 'view'" title="Add Line Item" icon="add_circle_outline" [showHeaderActions]="true">
    <div sectionActions>
      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="addProduct()"
        [disabled]="isApprovalStatus">
        <mat-icon>add</mat-icon>
        Add Line Item
      </button>
    </div>
    <div class="ui-doc-panel-content__add-form">
      <form [formGroup]="productForm" class="ui-doc-panel-content__add-form-inner">
        <div class="ui-doc-panel-content__field ui-doc-panel-content__field--full" *ngIf="document_type === 'Goods'">
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="Search Item ..." [formControl]="dataControl" [matAutocomplete]="auto" (input)="filterItems()">
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onItemChange($event.option.value)">
              <mat-option *ngFor="let item of filtered_item_data" [value]="item.item_id">{{ item.item_name }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field ui-doc-panel-content__field--full" *ngIf="document_type === 'Fixed Asset'">
          <mat-form-field appearance="outline">
            <input type="text" matInput placeholder="Search Item ..." [formControl]="dataControl" [matAutocomplete]="autoFa" (input)="filterItems()">
            <mat-autocomplete #autoFa="matAutocomplete" (optionSelected)="onFaItemChange($event.option.value)">
              <mat-option *ngFor="let item of filtered_fa_item_data" [value]="item.id">{{ item.name }}</mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field" *ngIf="document_type === 'Goods'">
          <mat-form-field appearance="outline">
            <mat-label>Sku Name</mat-label>
            <input matInput formControlName="sku_name" placeholder="Sku Name" [readonly]="isSku"/>
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field" *ngIf="document_type === 'Services'">
          <mat-form-field appearance="outline">
            <mat-label>Select Service</mat-label>
            <mat-select formControlName="selectedServiceId" placeholder="Select Service" (selectionChange)="onServiceChange($event.value)">
              <mat-option value="">Select Service</mat-option>
              <mat-option *ngFor="let service of service_data" [value]="service.id">{{ service.service_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field">
          <mat-form-field appearance="outline">
            <mat-label>HSN No</mat-label>
            <input matInput formControlName="hsn_no" placeholder="HSN_No" [readonly]="isHsnNo" />
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field">
          <mat-form-field appearance="outline">
            <mat-label>specification</mat-label>
            <input matInput formControlName="specification" placeholder="specification" />
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field">
          <mat-form-field appearance="outline">
            <mat-label>Comment</mat-label>
            <input matInput formControlName="description" placeholder="Comment" />
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field">
          <mat-form-field appearance="outline">
            <mat-label>Unit of Measure (UOM)</mat-label>
            <mat-select formControlName="uom" required>
              <mat-option *ngFor="let unit of unit_data" [value]="unit">{{ unit.unit_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field">
          <mat-form-field appearance="outline">
            <mat-label>Quantity</mat-label>
            <input type="number" matInput formControlName="quantity" min="0.001" step="0.001" (keypress)="allowOnlyNumbers($event)" (input)="checkReorderLevel($event.target.value)" required />
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field">
          <mat-form-field appearance="outline">
            <mat-label>Price</mat-label>
            <input matInput formControlName="price" min="0.01" step="0.01" placeholder="Price" type="number" [readonly]="document_type === 'Goods'" required/>
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field">
          <mat-form-field appearance="outline">
            <mat-label>Start Date</mat-label>
            <input type="date" matInput formControlName="start_date" [min]="today" [max]="today" required (keydown)="$event.preventDefault()" />
          </mat-form-field>
        </div>

        <div class="ui-doc-panel-content__field">
          <mat-form-field appearance="outline">
            <mat-label>Delivery Date</mat-label>
            <input type="date" matInput formControlName="end_date" required (keydown)="$event.preventDefault()" />
          </mat-form-field>
        </div>
      </form>
    </div>
  </app-ui-form-section>

  <!-- Line Items -->
  <app-ui-form-section title="Line Items" icon="list_alt" [showHeaderActions]="document_type && panelMode !== 'view'">
    <div sectionActions *ngIf="document_type && panelMode !== 'view'">
      <button mat-icon-button color="primary" matTooltip="Download Sample" (click)="lineItemSample()">
        <mat-icon>download</mat-icon>
      </button>
      <button mat-icon-button color="accent" matTooltip="Import from Excel" (click)="fileInput.click()">
        <mat-icon>upload_file</mat-icon>
      </button>
      <button mat-icon-button color="warn" matTooltip="Export Details" (click)="exportDetails()">
        <mat-icon>file_upload</mat-icon>
      </button>
      <input type="file" #fileInput (change)="lineItemImport()" multiple accept=".xlsx,.xls" hidden />
    </div>

    <div class="ui-doc-panel-content__table-wrap">
      <table class="ui-doc-table">
        <thead>
          <tr>
            <th>Category Name</th>
            <th *ngIf="document_type === 'Goods'">Item Name</th>
            <th>Item/Service</th>
            <th>Ledger Name</th>
            <th>PC/CC Name</th>
            <th>Branch Name</th>
            <th>HSN No</th>
            <th>Specification</th>
            <th>Comment</th>
            <th>UOM</th>
            <th>Quantity</th>
            <th>Price</th>
            <th>Value</th>
            <th>Start Date</th>
            <th>Delivery Date</th>
            <th *ngIf="panelMode !== 'view'">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of products; let i = index">
            <td matTooltip="{{ product.category_name }}" matTooltipShowDelay="750">{{ product.category_name }}</td>
            <td style="display: none;" *ngIf="document_type === 'Goods'">{{ product.category_id }}</td>
            <td *ngIf="document_type === 'Goods'" matTooltip="{{ product.item_name }}" matTooltipShowDelay="750">{{ product.item_name }}</td>
            <td style="display: none;" *ngIf="document_type === 'Goods'">{{ product.item_id }}</td>
            <td>
              <div *ngIf="document_type === 'Goods'">
                <ng-container *ngIf="product.isEditing; else goodsViewMode">
                  <mat-select [(ngModel)]="product.item_id" placeholder="Select Item"   (selectionChange)="onEditItemChange($event.value, i)">
                    <mat-option value="">Select Item</mat-option>
                    <mat-option *ngFor="let type of item_data" [value]="type.item_id">{{ type.item_name }}</mat-option>
                  </mat-select>
                </ng-container>
                <ng-template #goodsViewMode>{{ product.sku_name }}</ng-template>
              </div>
              <div *ngIf="document_type === 'Services'">
                <ng-container *ngIf="product.isEditing; else serviceViewMode">
                  <mat-select [(ngModel)]="product.selectedServiceId" placeholder="Select Service"    (selectionChange)="onEditServiceChange($event.value, i)">
                    <mat-option value="">Select Service</mat-option>
                    <mat-option *ngFor="let service of service_data" [value]="service.id">{{ service.service_name }}</mat-option>
                  </mat-select>
                </ng-container>
                <ng-template #serviceViewMode>
                  <span matTooltip="{{ product.service_name }}" matTooltipShowDelay="750">{{ product.service_name }}</span>
                </ng-template>
              </div>
              <div *ngIf="document_type === 'Fixed Asset'">
                <ng-container *ngIf="product.isEditing; else faViewMode">
                  <mat-select [(ngModel)]="product.item_id" placeholder="Select Item" (selectionChange)="onFaItemChange($event.value)">
                    <mat-option value="">Select Item</mat-option>
                    <mat-option *ngFor="let type of filtered_fa_item_data" [value]="type.id">{{ type.name }}</mat-option>
                  </mat-select>
                </ng-container>
                <ng-template #faViewMode>
                  <span matTooltip="{{ product.name }}" matTooltipShowDelay="750">{{ product.name }}</span>
                </ng-template>
              </div>
            </td>
            <td>
              <span matTooltip="{{ product.ledger_name }}" matTooltipShowDelay="750">{{ product.ledger_name }}</span>
            </td>
            <td style="display: none;">{{ product.ledger_id }}</td>
            <td><span matTooltip="{{ product.profit_cost_name }}" matTooltipShowDelay="750">{{ product.profit_cost_name }}</span></td>
            <td style="display: none;">{{ product.profit_cost_id }}</td>
            <td><span matTooltip="{{ product.branch_name }}" matTooltipShowDelay="750">{{ product.branch_name }}</span></td>
            <td style="display: none;">{{ product.branch_id }}</td>
            <td style="display: none;">{{ product.type }}</td>
            <td><span matTooltip="{{ product.hsn_no }}" matTooltipShowDelay="750">{{ product.hsn_no }}</span></td>
            <td>
              <input [(ngModel)]="product.specification" [disabled]="!product.isEditing" matTooltip="{{ product.specification }}" matTooltipShowDelay="750" placeholder="Specification">
            </td>
            <td>
              <input [(ngModel)]="product.description" [disabled]="!product.isEditing" matTooltip="{{ product.description }}" matTooltipShowDelay="750" placeholder="Comment">
            </td>
            <td matTooltip="{{ product.uom }}" matTooltipShowDelay="750">{{ product.uom }}</td>
            <td *ngIf="document_type === 'Goods' || document_type === 'Services'">
              <input [(ngModel)]="product.quantity" [disabled]="!product.isEditing" type="number" placeholder="Quantity" step="0.001" min="0" (keypress)="allowOnlyNumbers($event)">
            </td>
            <td *ngIf="document_type === 'Fixed Asset'">
              {{ product.quantity || 0 | number:'1.3-3'}}
              <input [(ngModel)]="product.quantity" [disabled]="true" type="number" placeholder="Quantity" min="1" value="1" style="display: none;">
            </td>
            <!-- <td>{{ product.price || 0 | number:'1.2-2'}}</td> -->
            <td *ngIf="document_type === 'Goods' || document_type === 'Fixed Asset'">
              {{ product.price || 0 | number:'1.2-2' }}
            </td>
            
            <td *ngIf="document_type === 'Services'">
              <input type="number" [(ngModel)]="product.price" [disabled]="!product.isEditing" min="0" step="0.01">
            </td>
            <td>{{ (product.quantity || 0) * (product.price || 0) | number:'1.2-2'}}</td>
            <td>
              <input [(ngModel)]="product.start_date" [disabled]="!product.isEditing" type="date" [min]="today" [max]="today" [value]="today" placeholder="Start Date" (keydown)="$event.preventDefault()">
            </td>
            <td>
              <input [(ngModel)]="product.end_date" [disabled]="!product.isEditing" type="date" placeholder="End Date" (keydown)="$event.preventDefault()">
            </td>
            <td *ngIf="panelMode !== 'view'">
              <div class="ui-doc-panel-content__row-actions">
                <button *ngIf="!product.isEditing" mat-stroked-button color="primary" (click)="editProduct(i)">Edit</button>
                <button *ngIf="product.isEditing" mat-stroked-button color="primary" (click)="saveProduct(i)">Save</button>
                <button mat-stroked-button color="warn" (click)="removeProduct(i)">Remove</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </app-ui-form-section>

  <!-- Remarks -->
  <app-ui-form-section title="Remarks" icon="notes">
    <mat-form-field appearance="outline" class="ui-doc-panel-content__remark">
      <mat-label>Enter Remark</mat-label>
      <textarea matInput [(ngModel)]="remark" placeholder="Enter Remark" [disabled]="isInputDisabled" rows="3"></textarea>
    </mat-form-field>
  </app-ui-form-section>

  <!-- Budget Summary -->
  <app-ui-form-section *ngIf="calculated_budget && Object.keys(calculated_budget).length > 0" title="Budget Summary" icon="account_balance">
    <div class="ui-doc-panel-content__table-wrap">
      <table class="ui-doc-table">
        <thead>
          <tr>
            <th>Category Name</th>
            <th>Total Budget</th>
            <th>Open Requisition</th>
            <th>Requisition Pending For Approval</th>
            <th>Requisition Approved</th>
            <th>Current Requisition</th>
            <th>Balance</th>
            <th>Open Purchase Order</th>
            <th>PO Pending for Approval</th>
            <th>PO Approved</th>
            <th>Available Budget After PO</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let category of Object.keys(calculated_budget)">
            <td>{{ calculated_budget[category]?.category_name || category || 'Unknown' }}</td>
            <td><b>{{ calculated_budget[category]?.total_budget || 0 | number:'1.2-2' }}</b></td>
            <td>{{ calculated_budget[category]?.open_requisition || 0 | number:'1.2-2' }}</td>
            <td>{{ calculated_budget[category]?.requisition_pending_for_approval || 0 | number:'1.2-2' }}</td>
            <td>{{ calculated_budget[category]?.requisition_approved || 0 | number:'1.2-2' }}</td>
            <td><b>{{ calculated_budget[category]?.current_requisition || 0 | number:'1.2-2' }}</b></td>
            <td><b>{{ calculated_budget[category]?.balance || 0 | number:'1.2-2' }}</b></td>
            <td>{{ calculated_budget[category]?.open_purchase_order || 0 | number:'1.2-2' }}</td>
            <td>{{ calculated_budget[category]?.po_pending_for_approval || 0 | number:'1.2-2' }}</td>
            <td>{{ calculated_budget[category]?.po_approved || 0 | number:'1.2-2' }}</td>
            <td><b>{{ calculated_budget[category]?.available_budget_after_po || 0 | number:'1.2-2' }}</b></td>
          </tr>
        </tbody>
      </table>
    </div>
  </app-ui-form-section>

<app-ui-document-panel-footer
  [primaryActions]="footerPrimaryActions"
  [secondaryActions]="footerSecondaryActions"
  [destructiveAction]="footerDestructiveAction"
  [overflowActions]="footerOverflowActions"
  (actionClick)="onFooterAction($event)">
</app-ui-document-panel-footer>

</app-ui-document-panel-shell>
